import React, { useEffect, useState } from 'react'

const startDate = new Date('2023-03-01T00:00:00');
const calculatedDaysPassed = ()=>{
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - startDate.getTime();
    const daysPassed = Math.floor(timeDifference / (1000*60*60*24));
    return daysPassed >= 0 ? daysPassed : 0
}

export default function Experience() {
    const [daysPassed, setDaysPassed] = useState(calculatedDaysPassed);
    useEffect(()=>{
        const interval = setInterval(()=>{
            setDaysPassed(calculatedDaysPassed);
        },1000);

        return () => clearInterval(interval)
    },[]);
  return (
    <div className='w-full min-h-[85vh] lg:min-h-[78vh] mt-24 rounded-3xl flex justify-center items-cente'>
       <div className="flex-col pt-36 p-4 text-center">
       <h2 className='text-cyan text-[36px] font-bold text-center'><span className='text-lime text-[42px]'>{daysPassed}</span> Days of Web Development Experience</h2>
       <br />
        <h2 className='text-primary text-[36px] font-bold  text-center'><span className='text-amber text-[42px]'>+8</span> Years of Development Experience</h2>
       </div>
    </div>
  )
}
